import React, { useState } from "react";
import { Link } from "react-router-dom";

const FlyGroup = ({ groupName, items, icon }) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="submenu-group"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <div className="submenu-item has-children">
        <span className="submenu-label d-flex align-items-center">
          {items?.[0]?.Icon && (
            <span className="icon">
              {items[0].Icon}
            </span>
          )}
          <span className="submenu-text">
            {groupName}
          </span>
        </span>
        <span className="arrow submenu-text">▶</span>
      </div>

      {open && (
        <div className="submenu-panel right">
          {items.map((item) => (
            <Link 
              key={item?.ObjectType} 
              className="submenu-item" 
              to={item.path}
              style={{ 
                textDecoration: 'none', 
                color: 'inherit', 
                display: 'flex',
                alignItems: 'center',
                width: '100%' 
              }}
            >
              <span className="icon submenu-icon">
                {item?.Icon}
              </span>
              <span className="submenu-text">
                {item?.DiplayName}
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default FlyGroup;